import { Form, Modal, TextAreaField } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";

import { INTL_MESSAGES } from "./defined-messages";
import { useSendDealOwnerMessageMutation } from "./send-message-mutation";

type ContactFormProps = {
  productRequestId: string;
  placeholderText: string;
  customerDomain: string;
  dealOwnerName?: string | null;
  isModalOpen: boolean;
  handleClose: () => void;
};

export const ContactForm = ({
  productRequestId,
  placeholderText,
  customerDomain,
  dealOwnerName,
  isModalOpen,
  handleClose,
}: ContactFormProps) => {
  const intl = useIntl();
  const [message, setMessage] = useState<string>("");

  const onClose = () => {
    setMessage("");
    handleClose();
  };

  const { mutate: sendMessage, isPending } = useSendDealOwnerMessageMutation(
    dealOwnerName ?? "Wayflyer Support",
    onClose,
    productRequestId,
    customerDomain
  );

  const handleSubmit = () => {
    sendMessage({ message: message || placeholderText });
  };

  return (
    <Modal
      title={intl.formatMessage(INTL_MESSAGES.modalTitle, { name: dealOwnerName ?? "Wayflyer Support" })}
      isOpen={isModalOpen}
      onClose={onClose}
      closeOnClickElseWhere
    >
      <Form
        primaryAction={{
          content: intl.formatMessage(INTL_MESSAGES.contactFormSubmitBtnLabel),
          onAction: handleSubmit,
          loading: isPending,
        }}
        secondaryAction={{
          content: intl.formatMessage(INTL_MESSAGES.contactFormCancelBtnLabel),
          onAction: onClose,
        }}
        onSubmit={() => {}}
      >
        <TextAreaField
          name="message"
          label={intl.formatMessage(INTL_MESSAGES.messageInputTitle)}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(e.target.value)}
          placeholder={placeholderText}
          allowVerticalResize
        />
      </Form>
    </Modal>
  );
};
